export default class Action {
    static REQUEST_MANAGER = 'REQUEST_MANAGER';
    static SHOW_FILE_BROWSER = 'SHOW_FILE_BROWSER';
    static SHOW_CONFIRMATION_DIALOG = 'SHOW_CONFIRMATION_DIALOG';
    static SHOW_MODAL_BOX = 'SHOW_MODAL_BOX';
    static SHOW_TOASTR = 'SHOW_TOASTR';
    static CLOSE_TOASTR_BY_ID = 'CLOSE_TOAST_BY_ID';
    static OTHER_STATES = 'OTHER_STATES';
    static AUTHENTICATION = 'AUTHENTICATION';
    static UNAUTHORIZED = 'UNAUTHORIZED';
    static UNKNOWN = 'UNKNOWN';
    static SET_USER_REVERSED_INFO = 'SET_USER_REVERSED_INFO';
    static PUBLIC_SYSTEM_CONFIGURATION = 'PUBLIC_SYSTEM_CONFIGURATION';
    static PUBLIC_SYSTEM_CONFIGURATION_ERROR = 'PUBLIC_SYSTEM_CONFIGURATION_ERROR';
    static SET_LEFT_MENU = 'SET_LEFT_MENU';
    static SET_USER_MANAGEMENT = 'SET_USER_MANAGEMENT';
    static SET_MASTER_DATA_VIEW = 'SET_MASTER_DATA_VIEW';
    static SET_MASTER_DATA = 'SET_MASTER_DATA';
    static SET_GG_RECAPTCHA_VALUE = 'SET_GG_RECAPTCHA_VALUE';
    static SET_UPLOAD_RESOURCE = 'SET_UPLOAD_RESOURCE';
    static SET_JOB_MANAGEMENT = 'SET_JOB_MANAGEMENT';
    static SET_ADS_MANAGEMENT = 'SET_ADS_MANAGEMENT';
    static SET_STORE_MANAGEMENT = 'SET_STORE_MANAGEMENT';
    static SET_CATEGORY_MANAGEMENT = 'SET_CATEGORY_MANAGEMENT';
    static SET_STORE_SELECTION = 'SET_STORE_SELECTION';
    static SET_COUPON_MANAGEMENT = 'SET_COUPON_MANAGEMENT';
    static SET_PRODUCT_MANAGEMENT = 'SET_PRODUCT_MANAGEMENT';
    static SET_SERVICE_STATE = 'SET_SERVICE_STATE';
    static SET_PRODUCT_PROFILE = 'SET_PRODUCT_PROFILE';
    static SET_ORDER_MANAGEMENT = 'SET_ORDER_MANAGEMENT';
    static SET_CALCULATION_FORMULA_MANAGEMENT = 'SET_CALCULATION_FORMULA_MANAGEMENT';

}
